export const ADMIN_DEBUG_UI_STORAGE_KEY = "viewspark.adminDebugUi";
export const ADMIN_DEBUG_UI_STORAGE_VALUE = "true";

function isAdminDebugUiLocalStorageEnabled(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return (
      localStorage.getItem(ADMIN_DEBUG_UI_STORAGE_KEY) ===
      ADMIN_DEBUG_UI_STORAGE_VALUE
    );
  } catch {
    return false;
  }
}

/**
 * Debug UI requires superadmin and a browser opt-in (no RTDB or custom claims).
 * Superadmins can toggle it from the profile menu. Console still works:
 *   localStorage.setItem("viewspark.adminDebugUi", "true");
 *   localStorage.removeItem("viewspark.adminDebugUi");
 */
export function isAdminDebugUiActive(isSuperadmin: boolean): boolean {
  return !!isSuperadmin && isAdminDebugUiLocalStorageEnabled();
}

/**
 * Flip the debug-UI localStorage flag. Returns whether it is enabled after the
 * write. Caller should reload so connected views re-read the flag.
 */
export function toggleAdminDebugUi(): boolean {
  if (typeof window === "undefined" || !window.localStorage) {
    return false;
  }
  try {
    if (isAdminDebugUiLocalStorageEnabled()) {
      window.localStorage.removeItem(ADMIN_DEBUG_UI_STORAGE_KEY);
      return false;
    }
    window.localStorage.setItem(
      ADMIN_DEBUG_UI_STORAGE_KEY,
      ADMIN_DEBUG_UI_STORAGE_VALUE
    );
    return true;
  } catch {
    return isAdminDebugUiLocalStorageEnabled();
  }
}
